import i18n from 'i18next';

export { t, changeLanguage } from 'i18next';

export const language = i18n.language;
